import type { AdminRole, ClaimStatus } from '@/lib/api-admin/types';

export type ClaimActionType = 'approve' | 'reject' | 'collect' | 'complete';

export const CLAIM_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'CS_AGENT',
  'OPS_ADMIN',
  'SUPER_ADMIN',
];

export const CLAIM_ACTION_RBAC: Record<ClaimActionType, ReadonlyArray<AdminRole>> = {
  approve: ['CS_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  reject: ['CS_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  collect: ['CS_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  complete: ['CS_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
};

const ALLOWED_STATUSES: Record<ClaimActionType, ReadonlyArray<ClaimStatus>> = {
  approve: ['REQUESTED', 'UNDER_REVIEW'],
  reject: ['REQUESTED', 'UNDER_REVIEW'],
  collect: ['COLLECTING'],
  complete: ['REFUND_PENDING'],
};

export const canPerformClaimAction = (
  action: ClaimActionType,
  roles: ReadonlyArray<AdminRole>,
): boolean => CLAIM_ACTION_RBAC[action].some((r) => roles.includes(r));

export const isStatusEligible = (
  action: ClaimActionType,
  status: ClaimStatus | null | undefined,
): boolean => {
  if (!status) return false;
  return ALLOWED_STATUSES[action].includes(status);
};
